import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";

const SEEN = "chatmilu.milu.brief.seen";

export const MiluBrief = () => {
  const [brief, setBrief] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(SEEN)) return;
    api.get("/wingman/handoff")
      .then(({ data }) => data.brief && setBrief(data))
      .catch(() => {});
  }, []);

  if (!brief) return null;

  return (
    <div className="lg:col-span-12" data-testid="milu-brief">
      <div className="flex items-start gap-3 rounded-2xl border border-brand/30 bg-brand/5 px-4 py-3">
        <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
        <div className="min-w-0 flex-1">
          <p className="text-[11px] uppercase tracking-widest text-brand">From your chat with MiLu</p>
          <p className="mt-0.5 text-sm" dir="auto">{brief.brief}</p>
          {brief.wants?.length > 0 && (
            <p className="mt-1 flex flex-wrap gap-1.5">
              {brief.wants.map((w) => (
                <span key={w} data-testid={`milu-want-${w}`}
                      className="rounded-full border border-white/15 px-2 py-0.5 text-[11px] text-ink-soft">
                  {w}
                </span>
              ))}
            </p>
          )}
        </div>
        <button
          data-testid="milu-brief-close"
          onClick={() => {
            localStorage.setItem(SEEN, "1");
            setBrief(null);
          }}
          className="text-ink-soft transition-colors hover:text-ink"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
